import request from '@/utils/request'
import { commonPrefix, logisticsPrefix, packagePrefix } from './config'

// 获取国家群组列表
export const getCountryGroupList = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.get(`${logisticsPrefix}/common/country/combobox`, { data: params })
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 获取国家字母分类
export const getCountryLetterGroup = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.get(`${logisticsPrefix}/common/country/alphabet/list`, {
      data: params,
    })
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}
// 获取省列表
export const getProvinceList = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${commonPrefix}/country/state/list`, params)
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}
// 运费快递估算
export const estimationLogisticsPrice = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${logisticsPrefix}/estimate/route`, params)
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 获取承运商列表
export const getCarrierList = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.get(`${logisticsPrefix}/carrier/combobox`, {
      data: params,
    })
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 获取承运商产品
export const getCarrierProductList = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.get(`${logisticsPrefix}/carrier/product/combobox`, { data: params })
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 获取承运商产品国家
export const getCarrierProductCountryList = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.get(`${logisticsPrefix}/carrier/product/country/combobox`, {
      data: params,
    })
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 承运商费用预估
export const carrierEstimation = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${logisticsPrefix}/logistics/api/estimate/price`, params)
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 计算商品体积
export const calcProductVolume = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${logisticsPrefix}/estimateItemVolume`, params)
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 计算承运商路线
export const calcCarrierLines = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${logisticsPrefix}/estimate/items`, params)
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 获取快递信息
export const getExpressTrack = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${logisticsPrefix}/expressTrack`, params)
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}
// 获取线路邮寄限制
export const getLinesMailLimit = () => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.get(`${logisticsPrefix}/newMailLimit/getFirstMailLimit`)
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}
// 获取线路邮寄限制
export const getLinesMailLimitDetail = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.get(`${logisticsPrefix}/carrier/product/detail/mailLimit`, {
      data: params,
    })
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 获取线路邮寄限制
export const getLogisticsTraceList = (expressNo) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.get(`${logisticsPrefix}/track/trace/${expressNo}`, {
      data: { providersId: 1 },
    })
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}
// 获取快递公司
export const getExpressList = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.get(`${logisticsPrefix}/express/list`, {
      data: params,
    })
    if (res.code === 0 || res.code === 200) {
      resolve(res.rows)
    } else {
      reject(res.msg)
    }
  })
}

// 承运商费用预估
export const logisticsNotice = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${logisticsPrefix}/notice/query`, params)
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}

// 用户新增定制物流
export const customizedCreate = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${packagePrefix}/api/customized/create`, params)
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}
// 首页轮播图
export const getBannerList = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.get(`${commonPrefix}/advert/page`, { data: params })
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}
// 获取国家可选线路
export const getCountryLineNum = (params) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await request.post(`${logisticsPrefix}/estimate/linecount`, params)
    if (res.code === 0 || res.code === 200) {
      resolve(res.data)
    } else {
      reject(res.msg)
    }
  })
}
